import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UpdatePicService {
  private servicoFoto = new BehaviorSubject<string>(null);

  service(): Observable<any> {
    return this.servicoFoto.asObservable();
  }

  setNewFile(newfile: string): void {
    this.servicoFoto.next(newfile);
  }
}
